;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.common.services')
    .service('DownloaderService', DownloaderService)

  DownloaderService.$inject = ['zlAuth', 'urls']

  /**
   * Constructor
   * Utils for Downloader-related operations.
   */
  function DownloaderService (zlAuth, urls) {
    var self = this

    /**
     * Builds the url to download the content of a file and opens if in a new window.
     * @param {Object} file
     * @param {string} file._id the file must have a valid _id
     */
    function downloadFile (file) {
      zlAuth.getToken().then(function (tokn) {
        window.open(urls.downloader + '/object/' + file._id + '?token=' + tokn, '_blank')
      })
    }

    _.extend(self, {
      downloadFile: downloadFile
    })
  }
})(window.angular, window._)
